"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import * as motion from "motion/react-client";
import { useTranslations } from "next-intl";
import { useState } from "react";
import Project from "./project";
const INITIAL_COUNT = 6;
const projects = [{
  name: "chattaconlalegge",
  title: "ChattaConLaLegge.it",
  href: "https://chattaconlalegge.it",
  types: ["web"] as ("web" | "mobile")[],
  image: "/images/projects/chattaconlalegge.png"
}, {
  name: "haccpclick",
  title: "HACCPClick",
  href: "https://haccp.click",
  types: ["web", "mobile"] as ("web" | "mobile")[],
  image: "/images/projects/haccpclick.png"
}, {
  name: "controllalatruffa",
  title: "ControllaLaTruffa.it",
  href: "https://controllalatruffa.it",
  types: ["web"] as ("web" | "mobile")[],
  image: "/images/projects/controllalatruffa.png"
}, {
  name: "brickpro",
  title: "BrickPro",
  href: "https://brickpro.tesei.eu",
  types: ["web"] as ("web" | "mobile")[],
  image: "/images/projects/brickpro.png"
}, {
  name: "lavala",
  title: "Lavala",
  href: "https://lavala.app",
  types: ["mobile"] as ("web" | "mobile")[],
  image: "/images/projects/lavala.png"
}, {
  name: "vammon",
  title: "Vammon",
  href: "https://www.vammon.com",
  types: ["web", "mobile"] as ("web" | "mobile")[],
  image: "/images/projects/vammon.jpg"
}, {
  name: "specialist",
  title: "Specialist App",
  href: "https://www.producthunt.com/products/specialist-2",
  types: ["mobile"] as ("web" | "mobile")[],
  image: "/images/projects/specialist.jpg"
}, {
  name: "powermeter",
  title: "PowerMeter",
  href: "https://www.powermeter.info/index.php/features-app",
  types: ["mobile"] as ("web" | "mobile")[],
  image: "/images/projects/powermeter.jpg"
}, {
  name: "winintegracloud",
  title: "WinIntegra Cloud",
  href: "https://www.winintegracloud.it/app-ios-android/",
  types: ["mobile"] as ("web" | "mobile")[],
  image: "/images/projects/winintegracloud.jpg"
}, {
  name: "manybox",
  title: "ManyBox",
  href: "https://www.producthunt.com/products/manybox",
  types: ["mobile"] as ("web" | "mobile")[],
  image: "/images/projects/manybox.jpg"
}, {
  name: "looksbetter",
  title: "LooksBetter",
  href: "https://www.producthunt.com/products/looksbetter",
  types: ["web"] as ("web" | "mobile")[],
  image: "/images/projects/looksbetter.jpg"
}, {
  name: "generacodicifiscali",
  title: "Genera Codici Fiscali",
  href: "https://generacodicifiscali.it",
  types: ["web"] as ("web" | "mobile")[],
  image: "/images/projects/generacodicifiscali.jpg"
}];
const Projects = () => {
  const $ = _c(14);
  const t = useTranslations("Home");
  const [showAll, setShowAll] = useState(false);
  let t0;
  let t1;
  let t2;
  if ($[0] !== showAll) {
    const visible = showAll ? projects : projects.slice(0, INITIAL_COUNT);
    t2 = "flex flex-col gap-6";
    t0 = "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5";
    t1 = visible.map(_temp);
    $[0] = showAll;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1) {
    t3 = <div className={t0}>{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== showAll || $[8] !== t) {
    t4 = projects.length > INITIAL_COUNT && <motion.div initial={{
      opacity: 0,
      translateY: 10
    }} whileInView={{
      opacity: 1,
      translateY: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.3,
      duration: 0.5,
      ease: "easeOut"
    }} className="flex justify-center"><motion.div whileHover={{
        scale: 1.04
      }} whileTap={{
        scale: 0.97
      }} transition={{
        type: "spring",
        stiffness: 400,
        damping: 17
      }}><Button type="button" variant="outline" size="sm" onClick={() => setShowAll(!showAll)}>{showAll ? <><ChevronUpIcon className="size-4" />{t("sections.projects.showLess")}</> : <><ChevronDownIcon className="size-4" />{t("sections.projects.showAll", {
              count: projects.length
            })}</>}</Button></motion.div></motion.div>;
    $[7] = showAll;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default Projects;
function _temp(project, index) {
  return <motion.div key={project.name} initial={{
    translateY: 30,
    opacity: 0
  }} whileInView={{
    translateY: 0,
    opacity: 1
  }} viewport={{
    once: true,
    margin: "-30px"
  }} transition={{
    duration: 0.5,
    delay: index * 0.1,
    ease: "easeOut"
  }}><Project name={project.name} title={project.title} href={project.href} types={project.types} image={project.image} /></motion.div>;
}